<template>
  <modal name="status" :scrollable="true" height="auto">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Status</h5>
        <button type="button" class="close" @click="$modal.hide('status')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div v-for="device of selectedDevices" class="device">
          <div v-if="device.loading">
            LOADING ...
          </div>
          <div v-else>
            <h5>DeviceID: {{device.deviceId}} <br> TeamViewerID: {{device.teamviewerId}}</h5>
            <ul>
              <li v-for="(value, key) of device.data" v-if="listToShow[key]">
                <strong>{{listToShow[key].name}}</strong>: <span> {{value}}</span>
              </li>
            </ul>
          </div>
          <hr v-if="selectedDevices.length > 1">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="$modal.hide('status')">OK</button>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
    name: 'StatusModal',
    data () {
        return {
            colors: [
                { color: '#ea2800', percentage: 15 },
                { color: '#f07100', percentage: 30 },
                { color: '#f9bd00', percentage: 40 },
                { color: '#f3e002', percentage: 55 },
                { color: '#deed00', percentage: 70 },
                { color: '#8ada00', percentage: 85 },
                { color: '#00da3e', percentage: 100 }
            ],
            listToShow: {
              DISK_USAGE_PERCENTAGE: {
                name: 'disk usage in %'
              },
              MEDIA_STATUS: {
                name: "media status"
              },
              TEMPLATES_ENDPOINT: {
                name: "templates"
              },
              V_FAKE: {
                name: "version"
              },
              PRODUCTS_ENDPOINT: {
                name: "products"
              },
              PRICES_ENDPOINT: {
                name: "prices"
              },
              lastStatus: {
                name: "lastStatus"
              }
            }
        };
    },
    props: {
      selectedDevices: Array
    },
    computed: {

    },
    methods: {
        showActionsModal () {
            this.$modal.hide('status');
        },
        beforeClose () {

        }
    }
};
</script>

<style lang="scss" scoped>
  ul{
    list-style-type: none;
  }
  .device{

  }
</style>
